import axios from 'axios';

export default class AppConfigService {
    constructor() {
        this.baseUrl = process.env.NODE_ENV === 'production'
            ? 'https://nextapi.logonomy.ir'
            : 'http://localhost:5051';
    }


    getAllModules = () => {
        return axios.get(`${this.baseUrl}/api/AppConfig/AllModules`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("jwt")
            },
        })
            .then(res => res.data);
    }

    getAllEnums = () => {
        return axios.get(`${this.baseUrl}/api/AppConfig/AllEnums`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("jwt")
            },
        })
            .then(res => res.data);
    }

}
